export const AlwaysAvailablePhaseCode = {
    TravelTime: '0000-0150',
    PunchList: '0000-0170',
};

export const isAlwaysAvailable = (contractPhase) => {
    return (
        contractPhase &&
        contractPhase.displayPhase &&
        (contractPhase.displayPhase == AlwaysAvailablePhaseCode.TravelTime ||
            contractPhase.displayPhase == AlwaysAvailablePhaseCode.PunchList)
    );
};
